var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-table", {
    ref: "table",
    staticClass: "q-mt-lg",
    attrs: {
      data: _vm.audios,
      columns: _vm.columns_audios,
      "row-key": "id",
      pagination: _vm.server_pagination,
      loading: _vm.loading,
      "no-data-label": _vm.$t("no_data_avaliable"),
      "no-results-label": _vm.$t("no_results_found"),
      "loading-label": _vm.$t("loading_data"),
      "rows-per-page-label": _vm.$t("items_per_page"),
      "rows-per-page-options": [5, 10, 50, 100],
      "binary-state-sort": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.server_pagination = $event
      },
      request: _vm.requestAudios
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function(props) {
          return _c(
            "q-tr",
            { attrs: { props: props } },
            _vm._l(props.cols, function(col) {
              return _c("q-th", { key: col.name, attrs: { props: props } }, [
                _vm._v(
                  "\n            " + _vm._s(_vm.$t(col.label)) + "\n        "
                )
              ])
            }),
            1
          )
        }
      },
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "q-tr",
              { attrs: { props: props } },
              [
                _c("q-td", { key: "title", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.title) +
                      "\n            "
                  )
                ]),
                _c("q-td", { key: "duration", attrs: { props: props } }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(props.row.duration) +
                      "\n            "
                  )
                ]),
                _c(
                  "q-td",
                  { key: "status", attrs: { props: props } },
                  [
                    _c(
                      "q-chip",
                      {
                        staticClass: "width-140 text-center",
                        attrs: {
                          small: "",
                          icon: _vm.getIconStatus(props.row.status),
                          color: _vm.getColorStatus(props.row.status)
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(_vm.getTextStatus(props.row.status))
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }